"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addGlobals = exports.unwrapPseudoGlobals = exports.hooks = exports.diagnostics = void 0;
const feature_1 = require("./feature");
const plugable_record_1 = require("../helpers/plugable-record");
const selector_1 = require("../helpers/selector");
const dataKey = plugable_record_1.plugableRecord.key('globals');
exports.diagnostics = {
    UNSUPPORTED_MULTI_SELECTOR_IN_GLOBAL() {
        return `unsupported multi selector in :global()`;
    },
};
// HOOKS
exports.hooks = (0, feature_1.createFeature)({
    metaInit({ meta }) {
        plugable_record_1.plugableRecord.set(meta.data, dataKey, {});
    },
    analyzeSelectorNode({ context, node, rule }) {
        var _a;
        if (node.value !== `global`) {
            return;
        }
        if (node.nodes && ((_a = node.nodes) === null || _a === void 0 ? void 0 : _a.length) > 1) {
            context.diagnostics.error(rule, exports.diagnostics.UNSUPPORTED_MULTI_SELECTOR_IN_GLOBAL(), {
                word: (0, selector_1.stringifySelector)(node.nodes),
            });
        }
        return selector_1.walkSelector.skipNested;
    },
    transformInit({ context }) {
        context.meta.globals = {};
    },
    transformLastPass({ context: { meta }, ast }) {
        ast.walkRules((r) => {
            if (!r.selector.includes(`:global(`)) {
                return;
            }
            const selectorAst = (0, selector_1.parseSelectorWithCache)(r.selector, { clone: true });
            const globals = unwrapPseudoGlobals(selectorAst);
            addGlobals(meta, globals);
            r.selector = (0, selector_1.stringifySelector)(selectorAst);
        });
    },
});
// API
function unwrapPseudoGlobals(selectorAst) {
    const collectedGlobals = [];
    (0, selector_1.walkSelector)(selectorAst, (node) => {
        var _a;
        if (node.type === 'pseudo_class' && node.value === 'global') {
            collectedGlobals.push(node);
            if (((_a = node.nodes) === null || _a === void 0 ? void 0 : _a.length) === 1) {
                (0, selector_1.flattenFunctionalSelector)(node);
            }
            return selector_1.walkSelector.skipNested;
        }
        return;
    });
    return collectedGlobals;
}
exports.unwrapPseudoGlobals = unwrapPseudoGlobals;
function addGlobals(meta, selectorAst) {
    for (const ast of selectorAst) {
        (0, selector_1.walkSelector)(ast, (inner) => {
            if (inner.type === 'class') {
                // ToDo: consider if to move to css-class feature.
                meta.globals[inner.value] = true;
            }
        });
    }
}
exports.addGlobals = addGlobals;
//# sourceMappingURL=st-global.js.map